module.exports = __webpack_public_path__ + "static/ordinace_015full-e5c3ec745be98ff5b4057da7f872a0c2.jpg";